import React from "react";
import { Link } from "react-router-dom";

const PageTitle = (props) => {
  return (
    <div className="header">
            <div className="header-title">
              <h1 className="header-h1">{props.name}</h1>
              <p className="header-p1">
                <Link to="/">{props.link}</Link> | <span>{props.page}</span>
              </p>
            </div>
          </div>
    
  );
};

export default PageTitle;
